import notify from "devextreme/ui/notify";
import { defineStore } from "pinia";

export const useToaster = defineStore("toast", () => {
  function error(text) {
    toast(text, 'error');
  }

  function success(text) {
    toast(text, 'success');
  }

  function warning(text) {
    toast(text, 'warning');
  }

  function toast(text, type) {
    notify({
        message: text,
        height: 45,
        width: 250,
        type: type,
        displayTime: 3000
      },{
        position: 'top center'
      }
    );
  }

  return {
    error,
    success,
    warning
  };
});
